(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/radio/radio.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/radio/radio.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  var _this = this;
  svs.tur.start_subscription.radio = new Backbone.Radio.channel('start-subscription');
  function callJupiter(method, path, data, context, successFn, errorFn) {
    let isHideLoader = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
    const options = {
      method,
      path
    };
    if (data) {
      options.data = data;
    }
    svs.components.loader.show();
    svs.core.jupiter.call(options, response => {
      if (isHideLoader) {
        svs.components.loader.hide();
      }
      if (typeof successFn === 'function') {
        successFn.call(context, response);
      }
    }, err => {
      if (typeof errorFn === 'function') {
        svs.components.loader.hide();
        errorFn.call(context, err);
      } else {
        svs.tur.start_subscription.radio.trigger('handleError', err);
      }
    });
  }
  const showDialog = (type, icon, title, message, actions) => {
    const dialog = new svs.ui.dialog.Confirm({
      branding: svs.ui.dialog.branding.TUR,
      type,
      icon,
      title,
      message: message.map(text => ({
        type: svs.ui.dialog.message.TEXT,
        text,
        align: svs.ui.dialog.message.align.CENTER
      })),
      actions
    });
    svs.ui.dialog.api.add(dialog);
  };
  svs.tur.start_subscription.radio.reply('checkSpendLimit', (amount, subscriptionId, context, successFn, cancelFn) => {
    const data = {
      amount
    };
    const handleSpendLimitError = err => {
      if (err && err.responseJSON && err.responseJSON.error) {
        const error = err.responseJSON.error;
        svs.tur.start_subscription.logger.info("Error spend limit for subscription. ErrorCode: ".concat(error === null || error === void 0 ? void 0 : error.code, ", Message: ").concat(decodeURI(error === null || error === void 0 ? void 0 : error.message)));
        if (error.code === 50105 || error.code === 50107) {
          if (subscriptionId) {
            svs.tur.start_subscription.radio.request('cancelSubscription', subscriptionId, context, () => {});
          }
          if (typeof cancelFn === 'function') {
            err._cancelFn = cancelFn;
            err._cancelFnContext = context;
          }
          svs.tur.start_subscription.radio.trigger('handleError', err);
          return;
        }
      }
      if (typeof successFn === 'function') {
        successFn.call(context);
      }
    };
    callJupiter('POST', "/gamblingcare/1/spendlimit/reserve/subscription/", data, context, successFn, handleSpendLimitError);
  });
  svs.tur.start_subscription.radio.reply('createPaymentAccess', (data, context, successFn) => {
    callJupiter('POST', "/payment/2/createpaymentaccess", data, context, successFn);
  });
  svs.tur.start_subscription.radio.reply('getSwedbankPayCheckoutObject', context => context && context.swedbankPayCheckout || undefined);

  svs.tur.start_subscription.radio.reply('makeCardPayment', (subscriptionId, amount, returnUrl, context) => {
    const data = {
      paymentType: 'creditcard',
      amount,
      returnUrl,
      subscriptionId
    };
    const successCallback = response => {
      window.location.href = response.redirectUrl;
    };
    callJupiter('PUT', '/player/1/transfer/subscription', data, context, successCallback);
  });
  svs.tur.start_subscription.radio.reply('makeSwedbankPayCardPayment', function (subscriptionId, amount, returnUrl, context) {
    let isActivating = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    const isComingBack = !(amount && returnUrl);
    const errFn = () => {
      const errorMessage = 'Ett fel har inträffat. Var god försök igen vid ett senare tillfälle.';
      const _dialog = new svs.ui.dialog.Confirm({
        icon: 'creditcard',
        branding: svs.ui.dialog.branding.TUR,
        type: svs.ui.dialog.type.ERROR,
        title: 'Det gick inte att starta din prenumeration',
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: errorMessage
        }],
        actions: [{
          title: 'Okej',
          callback: () => {
            svs.components.Modal.hide();
            if (context) {
              if (context.swedbankPayCheckout && context.swedbankPayCheckout.cleanUpSwedbankPayTransaction && typeof context.swedbankPayCheckout.cleanUpSwedbankPayTransaction === 'function') {
                context.swedbankPayCheckout.cleanUpSwedbankPayTransaction();
              }
              if (context.render && typeof context.render === 'function') {
                context.render();
              }
            }
            svs.components.Modal.hide();
            _dialog.close();
          }
        }]
      });
      svs.ui.dialog.api.add(_dialog);
    };
    const swpOptions = {
      isNotInfoText: true,
      prepareFn: () => {
        if (isComingBack) {
          $('.js-modal-container').show();
          svs.components.Modal && svs.components.Modal.currentView() && svs.components.Modal.currentView().trigger('modalContentResize');
        }
        $('.js-dropdown-form').hide();
        $('.js-pay-with-card-button-wrapper').hide();
        $('.subscription-info').hide();
        svs.components.Modal && svs.components.Modal.currentView() && svs.components.Modal.currentView().trigger('modalContentResize');
        for (let i = 1; i < 11; i++) {
          setTimeout(() => {
            svs.components.Modal && svs.components.Modal.currentView() && svs.components.Modal.currentView().trigger('modalContentResize');
          }, i * 1000);
        }
      },
      cleanUpFn: () => {
        $('.js-dropdown-form').show();
        $('.js-pay-with-card-button-wrapper').show();
        $('.subscription-info').show();
        svs.tur.start_subscription.utils.clearUrlParam('swpsubid');
        svs.tur.start_subscription.utils.clearUrlParam('act');
        if (isActivating) {
          if (context && context.entryModel && context.entryModel.get('paymentCancelled')) {
            svs.components.loader.show();
            setTimeout(() => location.reload(), 100);
          }
        }
      },
      errorFn: errFn,
      successFn: async () => {
        const subEntry = await svs.tur.start_subscription.utils.getSubEntryFromContextOrLocalStorage(context);
        const redirectUrl = svs.tur.start_subscription.utils.afterSubPayRedirectUrl(subEntry, subscriptionId);
        const redirectCallback = () => {
          if (context && context.view && context.view.triggerMethod && typeof context.view.triggerMethod === 'function') {
            context.view.triggerMethod('sendSavedTrackingData', () => {
              svs.utils.url.navigate(redirectUrl);
            });
          } else {
            svs.utils.url.navigate(redirectUrl);
          }
        };
        svs.components.Storage.browser.remove('templateObject', 'start_subscription');
        svs.components.Storage.browser.remove('start', 'subscription'); 
        svs.components.Storage.browser.remove('change', 'subscription'); 

        if (context && context.view && context.view.triggerMethod && typeof context.view.triggerMethod === 'function') {
          context.view.triggerMethod('activationSuccess');
        }
        const pollNewSub = (subscriptionId, callback) => {
          svs.components.loader.show();
          if (context && context.pollNewSubscription && typeof context.pollNewSubscription === 'function') {
            context.entryModel.set('newSubId', subscriptionId);
            if (!callback) {
              callback = redirectCallback.bind(context);
            }
            context.pollNewSubscription(callback);
          } else {
            svs.tur.start_subscription.radio.request('pollNewSubscription', subscriptionId, context || _this, redirectCallback(), redirectCallback());
          }
        };
        if (isActivating) {
          let activationSuccessCallback;
          svs.components.Modal.hide();
          svs.tur.start_subscription.logger.debug('Activating');

          if (context && context.view && context.view.showActivationSuccess && typeof context.view.showActivationSuccess === 'function') {
            activationSuccessCallback = context.view.showActivationSuccess.bind(context.view, "00000000".concat(subscriptionId).slice(-8));
          }
          pollNewSub(subscriptionId, activationSuccessCallback);
        } else {
          pollNewSub(subscriptionId);
        }
      },
      context
    };
    context.swedbankPayCheckout = new svs.accountservices.swedbankpay_checkout.SwedbankPayCheckout(swpOptions);
    if (!isComingBack) {
      context.swedbankPayCheckout.startSubscription(subscriptionId, amount, returnUrl);
    }
  });
  svs.tur.start_subscription.radio.reply('pollNewSubscription', (subscriptionId, context, successFn, errorFn) => {
    const maxRetries = 4;
    const retryDelay = 800;
    const method = 'GET';
    const path = "/player/1/subscription?subscription=".concat(subscriptionId);
    let retries = 0;
    const errorCallback = err => {
      const error = err && err.responseText && JSON.parse(err.responseText).error;
      if (error && (error.code === 1 || error.code === 3) && err.status === 400 && retries < maxRetries) {
        retries++;
        setTimeout(() => {
          callJupiter(method, path, null, context, successFn, errorCallback, false);
        }, retryDelay);
      } else {
        svs.components.loader.hide();
        if (typeof errorFn === 'function') {
          errorFn.call(context, err);
        }
      }
    };
    callJupiter(method, path, null, context, successFn, errorCallback, false);
  });
  svs.tur.start_subscription.radio.reply('changeSubscriptionPaymentType', (paymentType, context, successFn) => {
    callJupiter('PUT', "/subscription/2/paymenttype", {
      paymentType
    }, context, successFn);
  });
  svs.tur.start_subscription.radio.reply('setCommunicationType', successFn => {
    const successCallback = successFn || (() => svs.tur.start_subscription.radio.trigger('communicationTypeChanged'));
    callJupiter('PUT', "/subscription/2/communicationtype", {
      commType: 'EMAIL'
    }, null, successCallback);
  });
  svs.tur.start_subscription.radio.reply('cancelSubscription', function (subscriptionId, context, successFn) {
    let isHideLoader = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    let errorFn = arguments.length > 4 ? arguments[4] : undefined;
    if (!errorFn || typeof errorFn !== 'function') {
      errorFn = () => {
        svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
          branding: svs.ui.dialog.branding.TUR,
          type: svs.ui.dialog.type.ERROR,
          title: 'Prenumerationen kunde ej avslutas',
          message: [{
            type: svs.ui.dialog.message.TEXT,
            text: "Av n\xE5gon anledning kan prenumerationen ej avslutas f\xF6r tillf\xE4llet. V\xE4nligen f\xF6rs\xF6k igen eller kontakta <a href=\"".concat(svs.core.urlMapping.get('customerServiceHome'), "\">kundservice</a>")
          }],
          actions: [{
            title: 'Okej'
          }]
        }));
      };
    }
    callJupiter('PUT', '/subscription/2/disablesubscription', {
      subscriptionId
    }, context, successFn, errorFn, isHideLoader);
  });
  svs.tur.start_subscription.radio.on('handleError', xhr => {
    var _error, _error2;
    let error = {};
    let title = '';
    let message = [];
    let type = svs.ui.dialog.type.ERROR;
    let icon = '';
    let actions = [{
      title: 'Okej',
      callback: (e, forms, dialog) => {
        dialog.close();
        if (typeof (xhr === null || xhr === void 0 ? void 0 : xhr._cancelFn) === 'function') {
          xhr._cancelFn.call(xhr._cancelFnContext);
        } else {
          svs.events.publish('/subscription/activate/cancel');
        }
      }
    }];
    let showDefaultMessage = true;
    if (xhr && xhr.responseJSON) {
      error = xhr.responseJSON.error;
    }
    if (xhr && xhr.customError) {
      error.code = xhr.customError;
    }
    const loggerMessage = "Jupiter client call failed".concat(xhr === null || xhr === void 0 ? void 0 : xhr.status, " Message:").concat(xhr === null || xhr === void 0 ? void 0 : xhr.statusText, " ErrorCode: ").concat((_error = error) === null || _error === void 0 ? void 0 : _error.code, " ErrorMessage:").concat((_error2 = error) === null || _error2 === void 0 ? void 0 : _error2.message, "}");
    switch (error.code) {
      case '6 327':
        showDefaultMessage = false;
        svs.accountservices.suspension_message.showSuspensionMessage(() => {
          svs.events.publish('/subscription/activate/cancel');
        });
        svs.tur.start_subscription.logger.info(loggerMessage);
        break;
      case '3 107':
        title = 'Tekniskt fel';
        message = ['Vänligen försök logga ut och logga in igen.'];
        svs.tur.start_subscription.logger.info(loggerMessage);
        break;
      case '24 120':
        title = 'Inväntar godkänt autogiromedgivande';
        message = ['Din prenumeration aktiveras automatiskt när ditt autogiro har blivit godkänt. Om du har signerat ditt autogiromedgivande sker detta inom ett par dagar.'];
        svs.tur.start_subscription.logger.info(loggerMessage);
        break;
      case '24 118':
        title = 'Kommunikation via e-post';
        message = ['Vi kommer att kommunicera med dig via e-post istället för postalt framöver.'];
        type = svs.ui.dialog.type.INFO;
        icon = 'e-post';
        actions = [{
          title: 'Okej',
          callback: (e, forms, dialog) => {
            dialog.close();
            svs.tur.start_subscription.radio.request('setCommunicationType');
          }
        }];
        svs.tur.start_subscription.logger.info(loggerMessage);
        break;
      case '5 139':
        {
          svs.components.Modal.hide();
          title = 'Just nu kan du inte spela <br/> eller sätta in pengar';
          showDefaultMessage = false;
          type = svs.tur.apierrors.messageType.REGULAR;
          icon = 'exclamation-sign';
          const backupMessage = "<p> Visste du att du de senaste 24 timmarna har f\xF6rlorat mycket pengar? </p>\n          <p> Av omtanke om dig kan du d\xE4rf\xF6r inte s\xE4tta in pengar eller spela online eller i butik under 24 h. </p>\n          <p> Vill du prata med n\xE5gon om dina spelvanor? Du n\xE5r oss p\xE5 0770-11 11 11. </p>";
          const successFn = data => {
            var _data$endTime;
            const {
              amountLimit,
              endTime
            } = data;
            if (!amountLimit) {
              if (svs.core.detect.feature('ft-gaming-responsibility-contact')) {
                actions = [{
                  title: 'Stäng',
                  callback: (e, forms, dialog) => {
                    dialog.close();
                  }
                }, {
                  title: 'Kontakta oss',
                  callback: (e, forms, dialog) => {
                    dialog.close();
                    svs.utils.url.navigate('/spelkollskontakt');
                  }
                }];
                message = "<p>Anledningen till att du just nu inte kan spela eller s\xE4tta in pengar \xE4r att du den senaste tiden spelat mer riskfyllt.</p>\n                  <p>Innan du kan spela vidare beh\xF6ver du kontakta oss f\xF6r att prata om dina spelvanor. Du kan v\xE4lja mellan att chatta eller prata med n\xE5gon av v\xE5ra omsorgskommunikat\xF6rer.</p>";
              } else {
                message = "<p>Vi har f\xF6rs\xF6kt kontakta dig f\xF6r att hitta tid f\xF6r ett samtal om hur du k\xE4nner kring dina spelvanor. Tills vi f\xE5r tag p\xE5 dig kan du inte spela eller s\xE4tta in pengar.</p>\n                  <p>Kontakta oss p\xE5 0498-20 02 91 f\xF6r att hitta tid f\xF6r ett samtal.</p>";
              }
            } else if (!data.error && ((_data$endTime = data.endTime) === null || _data$endTime === void 0 ? void 0 : _data$endTime.length) > 0) {
              var _svs$utils$date$Short;
              const displayTime = (_svs$utils$date$Short = svs.utils.date.ShortDateAndTime(endTime, false, true)) === null || _svs$utils$date$Short === void 0 ? void 0 : _svs$utils$date$Short.toLowerCase();

              message = "<p> Visste du att du de senaste 24 timmarna har f\xF6rlorat mer \xE4n ".concat(svs.utils.format.Currency(amountLimit), " kr? </p>\n            <p> Av omtanke om dig kan du d\xE4rf\xF6r inte s\xE4tta in pengar eller spela online eller i butik just nu. Du kan spela igen ").concat(displayTime, ". </p>\n            <p> Vill du prata med n\xE5gon om dina spelvanor? Du n\xE5r oss p\xE5 0770-11 11 11. </p>");
            } else {
              message = backupMessage;
            }
            showDialog(type, icon, title, [message], actions);
          };
          const errorFn = () => {
            showDialog(type, icon, title, [backupMessage], actions);
          };
          callJupiter('GET', '/gcs/1/activenetlossrestriction', null, this, res => successFn(res), errorFn);
          svs.tur.start_subscription.logger.info(loggerMessage);
        }
        break;
      case 12420:
        title = 'Du är inte inloggad';
        message = ['Vänligen logga in och försök igen'];
        break;
      case '24 131':
        icon = 'exclamation-sign';
        type = svs.ui.dialog.type.INFO;
        title = 'Hoppsan!';
        message = ['Du kan prenumerera på max 10 lyckoplatser samma dragning.'];
        break;
      case 'autogiro':
        title = 'Det gick inte att signera ditt autogiromedgivande.';
        message = ['Kontrollera ditt automedgivande med din bank.', "Om problemet kvarst\xE5r, kontakta v\xE5r <a href=\"".concat(svs.core.urlMapping.get('customerServiceHome'), "\">Kundservice</a>")];
        svs.tur.start_subscription.logger.info('Error signing autogiro agreement for subscriptions.');
        break;
      case 50105:
        title = 'Det gick inte att starta prenumerationen';
        message = ['Du har ett pågående köp i butik.'];
        break;
      case 50107:
        title = 'Du kan inte starta prenumerationen';
        message = ["<p>Kostnaden f\xF6r prenumerationen \xF6verstiger din maxgr\xE4ns.</p> <a href=\"".concat(svs.core.urlMapping.get('myLimitsMax'), "\">L\xE4s mer om din maxgr\xE4ns</a>")];
        break;
      default:
        title = 'Något gick fel';
        message = ["Om problemet kvarst\xE5r, kontakta v\xE5r <a href=\"".concat(svs.core.urlMapping.get('customerServiceHome'), "\">Kundservice</a>")];
        svs.tur.start_subscription.logger.warn(loggerMessage);
        break;
    }
    svs.components.loader.hide();
    if (showDefaultMessage) {
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        type,
        icon,
        title,
        message: message.map(text => ({
          type: svs.ui.dialog.message.TEXT,
          text,
          align: svs.ui.dialog.message.align.CENTER
        })),
        actions
      });
      svs.ui.dialog.api.add(dialog);
    }
  });
})(Backbone, _, svs);

 })(window);